import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCustomFields, useSchema } from "@/contexts/contact";
import { useTrackingFormInteraction } from "@/hooks/tracking/useTrackingFormInteraction";
import { getFeaturesEnabled } from "@/utils/getFeaturesEnabled";
import { Box } from "@gemini/core";
import { useFormContext } from "react-hook-form";
import { EmailInput } from "./EmailInput";
import { FullNameInput } from "./FullNameInput";
import { MessageInput } from "./MessageInput";
import { PhoneNumberInput } from "./PhoneNumberInput";
import { SalutationInput } from "./SalutationInput";
import { StreetInput } from "./StreetInput";
import { ZipCityInput } from "./ZipCityInput";
import { contactFormFieldsTestId } from "./constants";
export const ContactFormFields = ({ contactFormDatas, tracking, }) => {
    const { extendedContactForm } = getFeaturesEnabled();
    const { locationEnabled } = useCustomFields();
    const { control } = useFormContext();
    const { trackFormInteraction } = useTrackingFormInteraction(tracking);
    const showExtendedContactForm = locationEnabled && extendedContactForm;
    const gap = "spacing.16";
    const handleFormFieldInteraction = () => {
        trackFormInteraction();
    };
    const { salutation, phoneNumber, street, zipCode, message } = useSchema().shape;
    return (_jsx(_Fragment, { children: _jsxs(Box, { testId: contactFormFieldsTestId, display: "flex", flexDirection: "column", gap: gap, onFocus: handleFormFieldInteraction, children: [_jsx(SalutationInput, { control: control, required: !salutation.isOptional() }), _jsx(FullNameInput, { control: control, required: true }), _jsx(EmailInput, { control: control, required: true }), _jsx(PhoneNumberInput, { control: control, required: !phoneNumber.isOptional() }), showExtendedContactForm && (_jsxs(_Fragment, { children: [_jsx(StreetInput, { control: control, required: !street.isOptional() }), _jsx(ZipCityInput, { control: control, required: !zipCode.isOptional() })] })), _jsx(MessageInput, { control: control, required: !message.isOptional(), contactFormDatas: contactFormDatas })] }) }));
};
